import React from 'react';
import ReactHlsPlayer from 'react-hls-player';

function HLSRenderer(props) {
    return (
        <ReactHlsPlayer {...props} autoPlay={true} width="100%" height="100%" controls={false} />
    );
}

export default HLSRenderer;